export const savePointKeys = {
  all: ["savePoint"] as const,
  projects: (projects: unknown) => [...savePointKeys.all, projects] as const,
  history: (projectId: string) => [...savePointKeys.all, projectId] as const,
};
